import React, { Component } from "react"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resetVehicle } from '../../../actions/vehicle'
import Search from '../Search';

class TyreSearch extends Component {
  componentWillUnmount() {
    this.props.resetVehicle()
  }

  render() {
    return <Search location={this.props.location} slug="home.dack" />
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  resetVehicle: () => resetVehicle()
}, dispatch)

export default connect(null, mapDispatchToProps)(TyreSearch)
